class ValidateAddress extends ValidatePage {
    constructor( _parent, address_name={ elm: '', id: '', classlist: '',  value: '' }, type={ elm: '', id: '', classlist: '',  value: '' }, address={ elm: '', id: '', classlist: '',  value: '' }, address2={ elm: '', id: '', classlist: '',  value: '' }, address3={ elm: '', id: '', classlist: '',  value: '' }, city={ elm: '', id: '', classlist: '',  value: '' }, country={ elm: '', id: '', classlist: '',  value: '' }, state={ elm: '', id: '', classlist: '',  value: '' }, zip={ elm: '', id: '', classlist: '',  value: '' }) {
        super();
        this.parent = _parent;
        this.address_name = address_name;
        this.type = type;
        this.address = address;
        this.address2 = address2;
        this.address3 = address3;
        this.city = city;
        this.country = country;
        this.state = state;
        this.zip = zip;
        this.is_valid = true;
        this.regex = {
            // address: /^(\s*[\+]?\s*1\s*[\.-]?)?\s*(\d{3}|\(\s*\d{3}\s*\))\s*[\.-]?\s*\d{3}\s*[\.-]?\s*\d{4}((\s|[\.-]){1}\s*[\.-]?\s*([extnsioEXTENSIO\.\:]{1,9}?\s*[\.-]?)?\d{1,7})?$/,
            zip: {
                US: {e: /^\d{5}(\-\d{4})?$/, t: 'LANG_LABEL_VALID_US_ZIP'},
                CA: {e: /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/, t: 'LANG_LABEL_VALID_CANADIAN_ZIP'},
                AUS: {e: /^([0-9]{4,4}$)/, t: 'LANG_LABEL_VALID_AUS_ZIP'}
            }
        }
        this.debug = this.parent.debug.extends.ValidateAddress; // Turn on debugger in ValidatePage
    }  

    async _validate($this){
        this.address_section = $this.parent().closest('.am-section-container--address');
        if(!this.address_section)
            this.address_section = $this.parent().closest('.js-address-wrapper');
        this.define_elems();
        var basic_validation = this.process_validations();

        if(basic_validation){
            this.is_valid = basic_validation;
            // const $address_container = $address.parent().closest('.js-address-wrapper')
            // console.log(this, "$this")
            // this.is_valid = await this.validatePlacesAddress();
        }
        else{
            this.is_valid = basic_validation;
        }

        if(this.debug)
            console.log(this, "ValidateAddress - debug");

        return this.is_valid
    }

    define_elems(){
        var inputs = this.address_section.find('input, select').not('[type="hidden"]');
        inputs.each((i, el) => {
            var $el = am.$(el);
            if($el.hasClass('js-address-name')){ this.address_name = this.parent.define_elem($el); }
            if($el.hasClass('js-address-type')){ this.type = this.parent.define_elem($el); }
            if($el.hasClass('js-address')){ this.address = this.parent.define_elem($el); }
            if($el.hasClass('js-address2')){ this.address2 = this.parent.define_elem($el); }
            if($el.hasClass('js-address3')){ this.address3 = this.parent.define_elem($el); }
            if($el.hasClass('js-address-city')){ this.city = this.parent.define_elem($el); }
            if($el.hasClass('js-address-country')){ this.country = this.parent.define_elem($el); }
            if($el.hasClass('js-address-state')){ this.state = this.parent.define_elem($el); }
            if($el.hasClass('js-address-zip')){ this.zip = this.parent.define_elem($el); }
        })
    }

    async validatePlacesAddress(){
        try{
            var address_format = '';
            const response = await am.$.ajax({
                url: `address/here`, // Replace with your server-side endpoint URL
                method: 'GET',
                data: { address: address_format }
            });
            
            this.response = response;
            
            // if (response.valid){
            //     return true
            // }else{
            //     if(response.sgEmailCheckObj && response.sgEmailCheckObj.resultObj.verdict == 'Invalid')
            //         this.parent.failed_obj_push( { target: this.email.id, msg:  'Email does not meet security standards. Reach out to {instance name} for assistance.' } );
            //     else
            //         this.parent.failed_obj_push( { target: this.email.id, msg: get_language_translation('EMAIL_ALREADY_TAKEN') } );
            //     return false;
            // }
        }
        catch(e){
            console.log(e);
        }
    }

    process_validations(){
        let passed = true;
        const select_allowed_values = ['billing', 'office', 'shipping', 'home', 'other'];
        if(!select_allowed_values.includes(this.type.value) && this.type.id != ''){
            this.parent.failed_obj_push( { target: this.type.id, msg: get_language_translation('REQUIRED_FIELD_LANG')});
            passed = false;
        }

        if(this.country.value != ''){
            var zip;
            switch (this.country.value) {
                case 'United States':
                    zip = { passed: this.regex.zip.US.e.test(this.zip.value), msg: this.regex.zip.US.t };
                    break;
                case 'Canada':
                    zip = { passed: this.regex.zip.CA.e.test(this.zip.value), msg: this.regex.zip.CA.t };
                    break;
                case 'Australia':
                    zip = { passed: this.regex.zip.AUS.e.test(this.zip.value), msg: this.regex.zip.AUS.t };
                    break;
                default:
                    zip = { passed: true };
                    this.zip.elm.trigger('blur');
                    break;
            }
            
            if(!zip.passed){
                this.parent.failed_obj_push( { target: this.zip.id, msg: get_language_translation(zip.msg) });
                passed = false;
            }
        }

        if(!passed)
            return false;
        else
            return true;
    }
} 